<template>
  <router-view/>
</template>
<script>
    export default {
    name: 'derechoDePeticionIndex'
    }
</script>

<style scoped>

</style>
